import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

function DrawerListItem({ listItemComponent, listItemAttributes, onClick, text, textStyles, Icon }) {
    const additionalAttributes = { ...(listItemAttributes && { ...listItemAttributes }) };
    return (
        <ListItem disablePadding button component={listItemComponent} onClick={onClick} {...additionalAttributes}>
            <ListItemButton>
                <ListItemIcon>{Icon && <Icon />}</ListItemIcon>
                <ListItemText primary={text} sx={{ color: '#1976d2', ...textStyles }} />
            </ListItemButton>
        </ListItem>
    );
}

export default DrawerListItem;
